import React from 'react'

interface LeaveConfirmationModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  children: React.ReactNode;
  confirmButtonText?: string;
}

const LeaveConfirmationModal: React.FC<LeaveConfirmationModalProps> = ({ onConfirm, onCancel, children, isLoading = false, confirmButtonText = "Yes" }) => {
  // Prevents click events from bubbling up to parent components
  const handleModalClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-auto flex items-center justify-center"
      onClick={onCancel}
      style={{ backgroundColor: 'rgba(60, 60, 60, 0.8)' }}
    >
      <div className="relative flex flex-col bg-white rounded-2xl shadow-xl max-w-sm w-full mx-4"
        onClick={handleModalClick}
        style={{ borderRadius: '16px', maxWidth: '29.9375rem' }}
      >
        <div className="px-6 pt-6 pb-4"
          style={{ color: 'black', fontSize: '1.32631rem', fontWeight: '500', lineHeight: 'normal' }}

        >
          <p className="text-black">
            {children}
          </p>
        </div>

        {/* Horizontal line */}
        <div className="border-t border-gray-300 mx-2"></div>

        <div className="flex justify-center gap-3 px-6 py-4">
          <button
            onClick={onCancel}
            disabled={isLoading}
            // className="px-5 py-2.5 rounded-lg text-sm font-medium disabled:opacity-50 transition-colors"
            style={{
              borderRadius: '0.625rem',
              width: '6.69531rem',
              height: '2.25rem',
              border: '1px solid #EFE9FA',
              background: '#F9F6FF',
              color: '#0A0A0A',
              textAlign: 'center',
              fontFamily: 'Poppins',
              fontSize: '0.875rem',
              fontWeight: '400',
              lineHeight: '1.25rem',
            }}
          onMouseEnter={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = '#D4B3FF';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#E8D5FF';
          }}
          >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={isLoading}
          // className="px-5 py-2.5 rounded-lg text-sm font-medium text-white disabled:opacity-50 transition-colors"
          style={{
            borderRadius: '0.625rem',
            width: '6.69531rem',
            height: '2.25rem',
            background: '#E56565',
            color: '#FFF',
            textAlign: 'center',
            fontFamily: 'Poppins',
            fontSize: '0.875rem',
            fontWeight: '400',
            lineHeight: '1.25rem',
          }}
          onMouseEnter={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = '#FF5252';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#FF6B6B';
          }}
        >
          {confirmButtonText}
        </button>
      </div>
    </div>
    </div >
  );
}

export default LeaveConfirmationModal